<a *ngIf="link" [routerLink]="[link]">
    {{title}}
</a>
<a *ngIf="!link">
    {{title}}
</a>
